import { useContext } from "react";

import { NotificationContext, type NotificationContextValue } from "./NotificationContext";

export function useNotificationContext(): NotificationContextValue {
  return useContext(NotificationContext);
}
